import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPageModule } from "../pages/login/login.module";
import { RestProvider } from '../providers/rest/rest';
import { DataProvider } from '../providers/data/data';
import {NgxPaginationModule} from 'ngx-pagination';

import { HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';
import { CalendarModule } from 'ion2-calendar';
import { CowRegister } from '../pages/cow_register/cow_register';
import { CowList } from '../pages/cow_list/cow_list';
import { Cow_Weight } from '../pages/cow_weight/cow_weight';
import { GraphicPage } from '../pages/cow_graphic/cow_graphic';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { QRScanner } from '@ionic-native/qr-scanner';
import { Camera } from '@ionic-native/camera';
import { SQLite } from '@ionic-native/sqlite';
import { SqliteProvider } from '../providers/sqlite/sqlite';
import { Cow_Notification } from '../pages/cow_notification/cow_notification';
import { DatePipe } from '@angular/common';
import { SimPage } from '../pages/sim/sim';
@NgModule({
  declarations: [
    MyApp,
    HomePage,
    CowRegister,
    CowList,
    Cow_Weight,
    Cow_Notification,
    GraphicPage,
    SimPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    LoginPageModule,
    HttpClientModule,
    NgxPaginationModule,
    CalendarModule,
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    CowRegister,
    CowList,
    Cow_Weight,
    GraphicPage,
    Cow_Notification,
    SimPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    RestProvider,
    DataProvider,
    SqliteProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler,},
    FileTransfer,
    FileTransferObject,
    File,
    Camera,
    QRScanner,
    SQLite,
    DatePipe
    // WebView,
    // BarcodeScanner
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts